module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumbBlurLarge/Sopranos-The-S2.837ebc2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumbBlurLarge/Sopranos-The-S2.jpg
// module id = bp8N
// module chunks = 0